<template>
    <div class="page apply-returns" v-loading="pageLoading">
        <!-- 头部 -->
        <head-bar title="申请退款" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <router-link to="/product/search">
                        <i class="head-search-icon"></i>
                    </router-link>
                    <router-link to="/">
                        <i class="head-home-icon"></i>
                    </router-link>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <transition name="van-fade">
            <div class="content" v-show="!pageLoading">
                <!-- 商品列表 -->
                <div class="goods-list">
                    <ul>
                        <li
                            v-for="(item, index) in orderDetailList"
                            :key="index"
                        >
                            <h4>{{ item.goodsName }}</h4>
                            <p>{{ item.factoryCode }}</p>
                            <p>{{ item.brandName }}</p>
                            <div class="other">
                                <div class="other-lf">
                                    <p>
                                        <span>含税原价</span>
                                        <em>¥&nbsp;{{ item.unitPrice }}</em>
                                    </p>
                                    <p>
                                        <span>购买数量</span>
                                        <em>{{ item.productQuantity }}pcs</em>
                                    </p>
                                    <p>
                                        <span>含税现价</span>
                                        <em>¥&nbsp;{{ item.currUnitPrice }}</em>
                                    </p>
                                    <p>
                                        <span>可退数量</span>
                                        <em>{{ item.returnCount }}pcs</em>
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 退款原因 -->
                <div class="field-box reason">
                    <van-field
                        label="退款原因"
                        :value="form.reason"
                        @click="showReasonPicker = true"
                        clickable
                        readonly
                    />
                    <i class="arrow-right-icon"></i>
                </div>
                <!-- 退款说明 -->
                <div class="field-box explain">
                    <van-field
                        label="退款说明"
                        v-model="form.explain"
                        type="textarea"
                        rows="1"
                        autosize
                        placeholder="选填项，详细退款说明"
                        maxlength="100"
                    />
                </div>
                <!-- 退款凭证 -->
                <div class="field-box img-list">
                    <van-field label="退款凭证" readonly />
                    <ul>
                        <li v-for="(item, index) in form.imgList" :key="index">
                            <div class="img-box">
                                <img :src="$config.QINIU_URL + item" />
                                <i @click="delPicture(index)"></i>
                            </div>
                        </li>
                        <li v-show="form.imgList.length < 3">
                            <div class="img-add">
                                <p>
                                    上传凭证
                                    <br />（最多3张）
                                </p>
                                <input type="file" @change="pictureChange" />
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
        <!-- 底部操作栏 -->
        <transition name="van-fade">
            <div class="apply-btn-box" v-show="!pageLoading">
                <van-button
                    type="default"
                    @click="$router.go(-1)"
                    size="small"
                    plain
                    round
                    >取消</van-button
                >
                <van-button
                    type="primary"
                    @click="handleSubmit"
                    size="small"
                    plain
                    round
                    >提交</van-button
                >
            </div>
        </transition>

        <!-- 退款原因选择器 -->
        <my-popup v-model="showReasonPicker" title="退款原因">
            <ul class="invoice-type">
                <li
                    v-for="(item, index) in reasonOpts"
                    @click="confirmReason(item)"
                    :key="index"
                >
                    {{ item }}
                </li>
            </ul>
        </my-popup>
    </div>
</template>

<script>
import HeadBar from "../../../components/HeadBar";
import MyPopup from "../../../components/MyPopup";
import Vue from "vue";
import { Field, Button } from "vant";
import { uploadFile } from "../../../utils/qiniu";

Vue.use(Field);
Vue.use(Button);

export default {
    components: { HeadBar, MyPopup },
    data() {
        return {
            pageLoading: false, // 页面loading
            /* 路由参数 */
            query: {
                orderNo: this.$route.query.orderNo,
            },
            returnType: 1, // 退款1 、退货2
            returnsDetail: {}, // 退款详情
            orderDetailList: [], // 商品列表
            /* 表单数据 */
            form: {
                reason: "", // 退款原因
                explain: "", // 退款说明
                imgList: [], // 退款凭证
            },
            /* 退款原因列表数据 */
            reasonOpts: ["买多了", "不想要了", "其他"],
            showReasonPicker: false, // 退款原因弹窗
        };
    },
    created() {
        this.getPageInfo();
    },
    methods: {
        /* 获取页面信息 */
        getPageInfo() {
            const url = this.$api.userApi.getGoodsReturnedInfo;
            const params = {
                orderNo: this.query.orderNo,
                salesReturnType: this.returnType,
            };

            this.pageLoading = true;
            this.$axios.post(url, params).then((res) => {
                const { orderDetailList } = res.data;
                this.returnsDetail = res.data;
                // 循环赋值 申请数量(productCount)为可退数量(returnCount)
                orderDetailList.forEach((item) => {
                    item.productCount = item.returnCount;
                });
                this.orderDetailList = orderDetailList;

                this.pageLoading = false;
            });
        },
        /* 提交 */
        handleSubmit() {
            // 退款原因验证
            if (!this.form.reason) {
                this.$toast("请选择退款原因");
                return;
            }

            const url = this.$api.userApi.saveReturned;
            const params = {
                orderNo: this.query.orderNo,
                salesReturnType: this.returnType,
                productParamList: this.orderDetailList,
                ...this.form,
            };
            this.$toast.loading({
                message: "正在提交...",
                duration: 0,
                forbidClick: true,
            });

            this.$axios
                .post(url, params)
                .then((res) => {
                    this.$toast.clear();
                    this.$router.go(-2);
                })
                .catch((err) => {
                    this.$toast.clear();
                });
        },
        /* 确认退款原因 */
        confirmReason(value) {
            this.form.reason = value;
            this.showReasonPicker = false;
        },
        /* 获取七牛云token */
        getQiniuToken() {
            return new Promise((resolve, reject) => {
                const url = this.$api.commonApi.getQiniuToken;
                this.$axios.post(url).then((res) => {
                    const token = res.data.uploadFileToken;
                    resolve(token);
                });
            });
        },
        /* 上传图片 */
        async pictureChange(event) {
            const token = await this.getQiniuToken();
            const file = event.target.files[0];

            uploadFile({
                folder: "flowcert",
                token,
                file,
                success: (res) => {
                    this.form.imgList.push(res.key);
                },
            });
        },
        /* 删除图片 */
        delPicture(index) {
            this.form.imgList.splice(index, 1);
        },
    },
};
</script>

<style lang="less" scoped>
.apply-returns {
    .head-right-slot {
        height: 100%;
        text-align: right;
        padding-right: 20px;

        i {
            display: inline-block;
            width: 60px;
            height: 100%;
            background-repeat: no-repeat;
            background-size: 48px;
            background-position: center;
            margin: 0 10px;

            &.head-search-icon {
                background-image: url(../../../public/images/head/head-search-icon.png);
            }

            &.head-home-icon {
                background-image: url(../../../public/images/head/head-home-icon.png);
            }
        }
    }

    .content {
        bottom: 100px;
        padding-bottom: 150px;

        .goods-list {
            ul {
                li {
                    margin-top: 20px;
                    background: #fff;
                    font-size: 24px;
                    padding: 28px 0 38px 102px;
                    position: relative;

                    i {
                        position: absolute;
                        left: 30px;
                        top: 62px;
                        width: 44px;
                        height: 44px;
                        background: url(../../../public/images/user/returns/radio-icon.png)
                            center no-repeat;
                        background-size: 44px;

                        &.checked {
                            background-image: url(../../../public/images/user/returns/radio-checked-icon.png);
                        }
                    }

                    > h4 {
                        font-weight: normal;
                        line-height: 32px;
                    }

                    > p {
                        color: #999;
                        margin-top: 6px;
                    }

                    .other {
                        border-top: 1px solid #f6f6f6;
                        margin-top: 30px;
                        padding-top: 30px;
                        overflow: hidden;

                        .other-lf,
                        .other-rt {
                            display: inline-block;
                            vertical-align: bottom;
                            width: 50%;
                        }

                        .other-lf {
                            p {
                                color: #666;

                                + p {
                                    margin-top: 8px;
                                }

                                span {
                                    margin-right: 20px;
                                }
                            }
                        }

                        .other-rt {
                            p {
                                color: #666;
                            }

                            strong {
                                display: inline-block;
                                width: 200px;
                                height: 46px;
                                line-height: 46px;
                                border: 1px solid #dedede;
                                text-align: center;
                                margin-top: 10px;
                                font-weight: normal;
                            }
                        }
                    }
                }
            }
        }

        .field-box {
            background: #fff;
            margin-top: 20px;

            .van-cell {
                padding: 32px 40px;
                font-size: 28px;
                line-height: 40px;

                /deep/ .van-field__label {
                    width: 140px;
                }
            }

            .van-cell:not(:last-child)::after {
                border-bottom: none;
            }
        }

        .reason {
            position: relative;

            /deep/ .van-field__control {
                text-align: right;
                color: #666;
                margin-right: 40px;
            }

            .arrow-right-icon {
                position: absolute;
                top: 50%;
                right: 40px;
                width: 40px;
                height: 40px;
                transform: translateY(-50%);
                background: url(../../../public/images/common/arrow-right-icon.png)
                    center no-repeat;
                background-size: 100%;
            }
        }

        .img-list {
            ul {
                padding: 0 40px 40px;
                overflow: hidden;

                li {
                    float: left;
                    width: 160px;
                    height: 160px;
                    margin-right: 30px;

                    .img-add {
                        height: 100%;
                        border: 1px dashed #999;
                        box-sizing: border-box;
                        background: url(../../../public/images/order/camera-icon.png)
                            center 22px no-repeat;
                        background-size: 56px;
                        position: relative;

                        p {
                            font-size: 20px;
                            color: #999;
                            text-align: center;
                            margin-top: 80px;
                        }

                        input {
                            opacity: 0;
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .img-box {
                        height: 100%;
                        position: relative;

                        img {
                            width: 100%;
                            height: 100%;
                        }

                        i {
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 40px;
                            height: 40px;
                            background: url(../../../public/images/order/close-icon.png)
                                center no-repeat;
                            background-size: 40px;
                        }
                    }
                }
            }
        }
    }

    .apply-btn-box {
        position: absolute;
        left: 0;
        bottom: 0;
        background: #fff;
        width: 100%;
        height: 100px;
        line-height: 100px;
        text-align: right;
        padding: 0 40px;
        box-sizing: border-box;

        .van-button {
            + .van-button {
                margin-left: 20px;
            }
        }
    }

    .invoice-type {
        padding: 0 30px;

        li {
            font-size: 28px;
            height: 116px;
            line-height: 116px;
            text-align: center;
            border-bottom: 1px solid #f2f2f2;

            &:first-child {
                border-top: 1px solid #f2f2f2;
            }
        }
    }
}
</style>
